import React, { useEffect, useState } from 'react'

const SectionOption = ({
  children,
  reqData,
  totalQuest,
  xSubName,
  ySecId,
  ...rest
}) => {
  const [disabledss, setDisabled] = useState(false);
  const disableee = () => {
    const datas = { ...reqData };
    const sectionArr = datas.Subjects[xSubName].filter(
      (x) => x.sec_id == ySecId
    );
    let additionOfQuestion = sectionArr.reduce(function (accumulator, object) {
      return accumulator + object.question;
    }, 0);
    const availableNoOfQuestions = totalQuest.SubTotalQuest.filter(
      (z) => z["TblSubject.sub_name"] === xSubName && z["TblSection.section_id"] == ySecId
      )[0].num_questions;
    if (additionOfQuestion == availableNoOfQuestions) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  useEffect(() => {
    disableee();
  }, [reqData]);

  return (
    <option {...rest} disabled={disabledss}>
      {children}
    </option>
  );
};

export default SectionOption;
